import {
  Component,
  ElementRef,
  inject,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ICityDto } from '@models/city-dto';
import { InscricaoCabecaChaveDto } from '@models/clash/clash-dto';
import { ClashListDto } from '@models/clash/clashes/clash-list-dto';
import { GroupKeyDto } from '@models/clash/group-key-dto';
import { GroupKeyForm } from '@models/clash/group-key-form-dto';
import { ClassificationDto } from '@models/competition/dtos/classification/classification-dto';
import { ICompleteEnrollmentDto } from '@models/complete-enrollment-dto';
import { ClashDto } from '@models/embate/clash-dto';
import { IPage } from '@models/pagination/page';
import { IPageable } from '@models/pagination/pageable';
import { IContactDto } from '@models/portal/users/dtos/contact-dto';
import { IDocumentDto } from '@models/portal/users/dtos/document-dto';
import { ITeachingInstitutionDto } from '@models/teaching-institution-dto';
import {
  FilterGamesTableService,
  FilterNavigationState,
} from '@modules/competition/games-table/filter-games-table/services/filter-games-table.service';
import { CityService } from '@shared/services/city.service';
import { ClashRegistrationService } from '@shared/services/competition/clash-registration/clash-registration.service';
import { ClashService } from '@shared/services/competition/clash.service';
import { ClassificationService } from '@shared/services/competition/classification/classification.service';
import { GroupKeyService } from '@shared/services/competition/group-key.service';
import { EnrollmentAthleteService } from '@shared/services/enrollment-athlete.service';
import { LoadingService } from '@shared/services/loading.service';
import { TeachingInstitutionService } from '@shared/services/teaching-institution.service';
import {
  IPublicPlaceDto,
  UserEventDto,
  UserEventService,
} from '@shared/services/user-event.service';
import { ControlsOf } from '@shared/types/form-group-of';
import { BaseComponent } from 'src/app/core/utilities/base-component/base-component';
import { TagStatusEnum } from './../../../../shared/components/chip-tag/chip-tag.component';

@Component({
  selector: 'sigecom-group-key',
  templateUrl: './group-key.component.html',
  styles: [
    `
      b {
        color: #7a7a7a;
      }
    `,
  ],
})
export class GroupKeyComponent extends BaseComponent implements OnInit {
  @ViewChild('nameInput') nameInput!: ElementRef<HTMLInputElement>;

  incNrId?: number;
  petNrId!: number;
  cheNrId!: number;
  petBlockEdit: boolean = false;

  TagStatusEnum = TagStatusEnum;

  abaSelecionada = '';
  selectedTab = 'Participantes';

  colunas = [
    { label: 'Pos.', propriedade: 'claNrPosicao' },
    { label: 'Participante', propriedade: 'incTxResumo' },
    { label: 'Pontos', propriedade: 'claNrPontos' },
    { label: 'Critério de desempate', propriedade: 'claTxCriterioDesempate' },
  ];

  modalViewClassification!: boolean;

  maxDisplayedPages = 10;

  #clashRegistration = inject(ClashRegistrationService);
  #classificationService = inject(ClassificationService);
  hasClashes: boolean = false;
  modalAddParticipants: boolean = false;
  modalAddRegistrations: boolean = false;
  modalArena: boolean = false;
  modalPlacar: boolean = false;
  atlNrId!: number;
  private lastCheTxNome?: string;
  clashListDto!: IPage<ClashListDto>;

  groupKeyDto?: GroupKeyDto;
  classificationDto?: IPage<ClassificationDto>;
  classification?: ClassificationDto;

  viewParticipants: boolean = false;
  viewParticipantInfo: boolean = false;
  viewParticipantDetail: boolean = false;
  viewRegistrations: boolean = false;

  parNrId?: number;
  embNrId?: number;
  page: number = 0;
  teams?: ClashListDto;
  iTeachingInstitutionDto?: ITeachingInstitutionDto;
  completeEnrollmentDto?: ICompleteEnrollmentDto;

  userEvent?: UserEventDto;
  userContact?: IPage<IContactDto>;
  userPublicPlace?: IPublicPlaceDto;
  userDataCity?: ICityDto;
  userDocument?: IPage<IDocumentDto>;
  drawAnimations: Record<
    number,
    { geral: boolean; cabeca: boolean; naoCabeca: boolean }
  > = {};

  #groupKeyService = inject(GroupKeyService);
  #clashService = inject(ClashService);
  #loadingService = inject(LoadingService);
  #atleteService = inject(EnrollmentAthleteService);
  userEventService = inject(UserEventService);
  teachingInstitutionService = inject(TeachingInstitutionService);
  clashRegistration = inject(ClashRegistrationService);
  filtroGamesTableService = inject(FilterGamesTableService);
  cityService = inject(CityService);
  elementRef = inject(ElementRef);
  inscritos = signal<number[]>([]);

  clashDto = signal<ClashDto | null>(null);
  cheQtdVencedores: number = 0;

  groupKeyForm = this.fb.group<ControlsOf<GroupKeyForm>>(
    {
      cheTxNome: this.fb.control<string>(''),
      cheNrEtapa: this.fb.control<number | null>(null),
      cheBlEmbGerados: this.fb.control<boolean | null>(false),
      cheNrQtdInc: this.fb.control<number | null>(null),
      cheNrQtdVencedor: this.fb.control<number | null>(null),
    },
    {
      validators: this.classificationCountValidator,
    },
  );

  incricoesChaveamentoPage?: IPage<InscricaoCabecaChaveDto>;
  incricoesChaveamentoPageable: IPageable = { page: 0, size: 100 };

  isNameEditing = false;
  participantInfo?: ICompleteEnrollmentDto;

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      const petNrId = params.get('petNrId');
      const cheNrId = params.get('cheNrId');
      this.petBlockEdit = params.get('petBlChaveBloqueada') === 'true';
      this.abaSelecionada = params.get('initialTab') || 'participantes';
      petNrId ? (this.petNrId = parseInt(petNrId)) : undefined;
      cheNrId ? (this.cheNrId = parseInt(cheNrId)) : undefined;
      if (this.abaSelecionada == 'participantes') {
        this.selectedTab = 'Participantes';
      } else {
        this.selectedTab = 'Classificação';
        this.#findClassification();
      }
    });

    this.#searchKeyById();
    this.#fetchParticipants();
    this.#fetchClashInfo();
  }

  setDrawState(
    itemId: number,
    tipo: 'geral' | 'cabeca' | 'naoCabeca',
    value: boolean,
  ) {
    if (!this.drawAnimations[itemId]) {
      this.drawAnimations[itemId] = {
        geral: false,
        cabeca: false,
        naoCabeca: false,
      };
    }
    this.drawAnimations[itemId][tipo] = value;
  }
  private classificationCountValidator(
    form: AbstractControl,
  ): ValidationErrors | null {
    const inscritos = form.get('cheNrQtdInc')?.value as number | null;
    const classificados = form.get('cheNrQtdVencedor')?.value as number | null;

    if (inscritos == null || classificados == null) {
      return null;
    }

    return classificados > inscritos ? { superioreAInscritos: true } : null;
  }

  #fetchParticipants(name?: string) {
    this.#clashService
      .getParticipants(this.cheNrId, name, this.incricoesChaveamentoPageable)
      .subscribe({
        next: (data) => {
          this.incricoesChaveamentoPage = data;
          this.#fetchClashInfo();
        },
      });
  }

  #fetchClashInfo() {
    this.#loadingService.activate();
    this.#clashService.getClash(this.cheNrId).subscribe({
      next: (data) => {
        this.inscritos.set(
          Array.from({ length: data.cheNrQtdInc! }, (_, i) => i),
        );
        this.cheQtdVencedores = data.cheNrQtdVencedor!;
        this.hasClashes =
          (data.cheListEmbates && data.cheListEmbates.length > 0) ?? false;
        this.initDrawStates();
        this.clashDto.set(data);
        this.setFormValue();
        this.#loadingService.deactivate();
      },
    });
  }

  openModalDetailParticipant() {
    this.viewParticipantDetail = true;
    console.log(this.atlNrId);
    this.closeModalViewParticipants();
  }

  setAtlNrId(value: number) {
    this.atlNrId = value;
  }

  initDrawStates() {
    const items = this.inscritos();
    for (let i = 0; i < items.length; i++) {
      this.drawAnimations[i] = {
        geral: false,
        cabeca: false,
        naoCabeca: false,
      };
    }
  }

  setFormValue() {
    this.groupKeyForm.patchValue({
      cheTxNome: this.clashDto()?.cheTxNome,
      cheNrEtapa: this.clashDto()?.cheNrEtapa,
      cheBlEmbGerados: this.clashDto()?.cheBlEmbGerados,
      cheNrQtdInc: this.clashDto()?.cheNrQtdInc,
      cheNrQtdVencedor: this.clashDto()?.cheNrQtdVencedor,
    });
  }
  saveInfo() {
    const cheTxNome = this.groupKeyForm.value.cheTxNome;
    this.#clashService
      .configureClash({
        cheTxNome: cheTxNome || '',
        cheNrId: this.cheNrId,
        petNrId: this.petNrId,
      })
      .subscribe({
        next: (_) => {
          this.snackbarService.showSuccess('Embate editado com sucesso');
          this.#fetchClashInfo();
          this.#listClashes();
          this.#findClassification();
        },
        error: (error) => {
          this.messageErrorResolver.resolveMessage(error);
          this.#fetchClashInfo();
        },
      });
  }
  allParticipantsAvaliableDraw(): void {
    this.#loadingService.activate();
    this.#groupKeyService
      .vincularSorteioTodosParticipantesDisponiveis(this.petNrId)
      .subscribe({
        next: () => {
          this.snackbarService.showSuccess(
            'Participantes sorteados com sucesso!',
          );
          this.#fetchParticipants();
        },
        error: (error) => {
          this.#loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(error);
          this.#fetchParticipants();
        },
      });
  }

  generalDraw(index: number): void {
    this.#loadingService.activate();
    this.setDrawState(index, 'geral', true);

    this.#groupKeyService
      .vincularSorteioGeral(this.petNrId, this.cheNrId)
      .subscribe({
        next: (res) => {
          setTimeout(() => {
            this.setDrawState(index, 'geral', false);
            this.snackbarService.showSuccess(
              'Participante sorteado com sucesso!',
            );
            this.#fetchParticipants();
          }, 2000);
        },
        error: (error) => {
          setTimeout(() => {
            this.#loadingService.deactivate();
            this.messageErrorResolver.resolveMessage(error);
            this.setDrawState(index, 'geral', false);
          }, 2000);
        },
      });
  }

  setDadosClassification(classification: ClassificationDto) {
    this.classification = classification;
  }

  // headDraw(index: number): void {
  //   this.#loadingService.activate();

  //   this.setDrawState(index, 'cabeca', true);

  //   this.#groupKeyService
  //     .vincularSorteioCabecaChave(this.petNrId, this.cheNrId)
  //     .subscribe({
  //       next: (res) => {
  //         setTimeout(() => {
  //           this.setDrawState(index, 'cabeca', false);
  //           this.snackbarService.showSuccess(
  //             'Cabeça de chave sorteado com sucesso!'
  //           );
  //           this.#fetchParticipants();
  //         }, 2000);
  //       },
  //       error: (error) => {
  //         setTimeout(() => {
  //           this.#loadingService.deactivate();
  //           this.messageErrorResolver.resolveMessage(error);
  //           this.setDrawState(index, 'cabeca', false);
  //         }, 2000);
  //       },
  //     });
  // }

  abrirModal(event: boolean) {
    this.modalViewClassification = event;
  }

  closeModal() {
    this.modalViewClassification = false;
  }

  // notHeadDraw(index: number): void {
  //   this.#loadingService.activate();
  //   this.setDrawState(index, 'naoCabeca', true);

  //   this.#groupKeyService
  //     .vincularSorteioNaoCabecaChave(this.petNrId, this.cheNrId)
  //     .subscribe({
  //       next: (res) => {
  //         setTimeout(() => {
  //           this.setDrawState(index, 'naoCabeca', false);
  //           this.snackbarService.showSuccess(
  //             'Participante sorteado (não cabeça de chave) com sucesso!'
  //           );
  //           this.#fetchParticipants();
  //         });
  //       },
  //       error: (err) => {
  //         setTimeout(() => {
  //           this.#loadingService.deactivate();
  //           this.messageErrorResolver.resolveMessage(err);
  //           this.setDrawState(index, 'naoCabeca', false);
  //         }, 2000);
  //       },
  //     });
  // }

  #searchKeyById() {
    this.#groupKeyService.searchKeyById(this.cheNrId).subscribe({
      next: (res) => {
        this.inscritos.set(
          Array.from({ length: res.response.cheNrQtdInc }, (_, i) => i),
        );
        this.groupKeyDto = res.response;
        this.#fetchParticipants();
      },
    });
  }

  participantAdded() {
    this.#searchKeyById();
    this.#listClashes();

    this.closeModalAddParticipants();
  }

  onPageChange(page: number) {
    this.page = page;
    this.#listClashes();
  }

  changeTab(tab: string) {
    if (tab.match('Confrontos')) {
      this.abaSelecionada = 'confrontos';
      this.page = 0;
      this.#listClashes();
    }

    if (tab.match('Classificação')) {
      this.abaSelecionada = 'classificacao';
      this.#findClassification();
    }
  }

  #findClassification() {
    this.#loadingService.activate();
    this.#classificationService
      .searchClassificationsByKey(this.cheNrId)
      .subscribe({
        next: (res) => {
          this.classificationDto = res.response;
          this.#loadingService.deactivate;
        },
      });
  }

  openModalAddParticipants(item?: number) {
    this.embNrId = item;
    this.modalAddParticipants = true;
  }

  enableNameEdit() {
    this.lastCheTxNome = this.groupKeyForm.get('cheTxNome')?.value ?? '';
    this.isNameEditing = true;
    setTimeout(() => {
      this.nameInput?.nativeElement?.focus();
    });
  }

  disableNameEdit() {
    this.isNameEditing = false;

    if (this.lastCheTxNome === this.groupKeyForm.get('cheTxNome')?.value)
      return;

    if (this.groupKeyForm.get('cheTxNome')?.value)
      this.#clashService
        .configureClash({
          cheTxNome: this.groupKeyForm.get('cheTxNome')?.value ?? '',
          cheNrId: this.cheNrId,
          petNrId: this.petNrId,
        })
        .subscribe({
          next: () => {
            this.#fetchClashInfo();
            this.snackbarService.showSuccess('Nome alterado com sucesso!');
          },
          error: (error) => {
            this.groupKeyForm
              .get('cheTxNome')
              ?.patchValue(this.lastCheTxNome ?? '');
            //this.messageErrorResolver.resolveMessage(error)
            this.snackbarService.showWarn(
              'O nome da chave Deve ter mais que 4 Caracteres',
            );
          },
        });
  }

  closeModalAddParticipants() {
    this.#listClashes();
    this.modalAddParticipants = false;
  }

  #listClashes() {
    console.warn('Tryed to list clashes', this.cheNrId);
    return;
    this.#clashRegistration
      .getRegistraionClash(undefined, { page: this.page, size: 10 })
      .pipe()
      .subscribe({
        next: (res) => {
          this.snackbarService.showSuccess('Confrontos carregados com sucesso');
          console.log(res);

          this.clashListDto = res;
        },
      });
  }

  openModalAddRegistrations() {
    this.modalAddRegistrations = true;
  }
  closeModalAddRegistrations() {
    this.modalAddRegistrations = false;
    this.viewRegistrations = false;
    this.#fetchParticipants();
  }
  openlocalCompetition() {
    this.modalArena = true;
  }
  closelocalCompetition() {
    this.modalArena = false;
  }
  openModalViewParticipants(valor: boolean) {
    this.viewParticipants = valor;
  }
  closeModalViewParticipants() {
    this.viewParticipantInfo = false;
    this.incNrId = undefined;
  }

  openScoreboard(equipes: ClashListDto) {
    this.teams = equipes;

    this.modalPlacar = true;
  }
  closeModalScoreboard() {
    this.modalPlacar = false;
    this.teams = undefined;
    this.#listClashes();
    this.#fetchParticipants();
  }

  deleteParticipant(ineNrId: number) {
    this.#groupKeyService
      .deletarInscricaoChave(this.cheNrId, ineNrId)
      .subscribe({
        next: (_) => this.#fetchParticipants(),
        error: (error) => this.messageErrorResolver.resolveMessage(error),
      });
  }

  searchConfrontations() {
    console.log('implemente');
  }

  searchParticipants() {
    console.log('implemente');
  }

  saveNumberOfEntriesAndRatings() {
    console.log('implemente');
  }

  openModalViewRegistrations(incNrId: number) {
    this.#atleteService.findCompleteById(incNrId!).subscribe({
      next: (data) => {
        this.completeEnrollmentDto = data;

        this.incNrId = incNrId;
        if (data.incObjParticipantes.length > 1) {
          console.log(data.incObjParticipantes.length);
          this.viewParticipantInfo = true;
        } else {
          if (data.incObjParticipantes.length != 0) {
            this.atlNrId = data.incObjParticipantes[0].atlNrId!;
            this.viewParticipantDetail = true;
          }
        }
        this.modalAddRegistrations = false;
      },
    });
  }

  drawClashes() {
    this.#clashRegistration.drawClashes(this.cheNrId).subscribe({
      next: () => {
        this.#listClashes();
      },
    });
  }

  drawClashesGeneral() {
    // this.drawAnimation = true;
    this.#clashRegistration.drawClashesGeneral(this.cheNrId).subscribe({
      next: () => {
        this.snackbarService.showSuccess('Sorteio geral realizado com sucesso');
        this.#listClashes();
      },
      error: (error) => this.messageErrorResolver.resolveMessage(error),
    });
  }
  deleteCompetiton(item: ClashListDto) {
    this.#clashRegistration.deleteClash(item.embNrId!).subscribe({
      next: () => {
        this.#listClashes();
        this.snackbarService.showSuccess('Confronto Deletado com Sucesso');
      },
      error: (error) => {
        this.messageErrorResolver.resolveMessage(error);
      },
    });
  }
  navigateToGamesTable() {
    const dto = this.clashDto();

    const step = dto?.parametrizacaoEtapaDto?.petNrId ?? null;
    const group = dto?.cheNrId ?? this.cheNrId ?? null;

    const filter = {
      petNrId: step,
      cheNrId: group,
    };
    this.router.navigate([`/tabela-jogos`], {
      queryParams: { filter: JSON.stringify(filter) },
    });
  }

  navigateToFase(petNrId: number) {
    this.router.navigate([`/parametrizacao-etapa/editar/${petNrId}`], {
      queryParams: { fromGroupKey: true },
    });
  }
}
